// <copyright file="token-refresh.config.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: by Sumanth Satheesh
// </copyright>

/**
 * Token Refresh Configuration
 * All timing values are in minutes for easy configuration
 */
export const TOKEN_REFRESH_CONFIG = {
  /**
   * Token validity duration in minutes
   * Default: 15 minutes
   */
  tokenValidityMinutes: 15,

  /**
   * Time in minutes after token issuance when silent refresh should be triggered
   * Default: 14 minutes (refresh 1 minute before expiry)
   * Must be less than TOKEN_VALIDITY_MINUTES
   * CONFIGURABLE: Change this value to adjust when refresh occurs
   */
  refreshAtMinute: 14,

  /**
   * Enable/disable token refresh (useful for testing)
   * Default: true
   */
  enableRefresh: true
};

/**
 * Convert minutes to milliseconds
 */
export function minutesToMs(minutes: number): number {
  return minutes * 60 * 1000;
}

/**
 * Get the refresh delay in milliseconds (time until refresh should occur)
 */
export function getRefreshDelayMs(): number {
  return minutesToMs(TOKEN_REFRESH_CONFIG.refreshAtMinute);
}
